// istanbul ignore file

//type/interface file which doesnt need to be tested

import type { CommonConsumer } from '@makemydeal/dr-platform-types';
import type { CustomerSideBarRequiredFields } from './CustomerSideBarRequiredFields';

export enum ConversationTypeEnum {
    ALL = 'all',
    TEXT = 'text',
    PHONE = 'phone',
    EMAIL = 'email',
    CHAT = 'chat',
    NONE = 'unknown'
}

interface OccConfig {
    disableReply?: boolean;
    username: string;
    defaultTab?: ConversationTypeEnum;
    messageContent?: string;
}

export type CustomerSideBarTab = 'information' | 'deal' | 'inbox' | undefined;

export type SimplifiedCardModuleProps = {
    commonConsumerID: string;
    editCapability?: 'enabled' | 'disabled' | 'hidden';
    enableReadOnlyEditFields?: boolean;
    environment: string;
    viewportMode?: 'desktop' | 'tablet' | 'mobile' | 'sidebar';
    doneCallback?: () => void;
    getAuthOverride?: () => string;
    onCustomerEdited?: (savedConsumer: CommonConsumer) => void;
    requiredFields?: CustomerSideBarRequiredFields[];
    occConfig?: OccConfig;
    defaultTab?: CustomerSideBarTab;
};
